import React from "react";
import Vimeo from "@u-wave/react-vimeo";

function VimeoPlayer(props) {
    const { url, watchTime, updateWatchTimes, thumbnail } = props;
  return (
    <div>
      <Vimeo
        video={url}
        autoplay={true}
        loop
        muted={false}
        showPortrait
        background={true}
        controls={true}
      />
    </div>
  );
}

export default VimeoPlayer;
